<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" :width="size" :height="size">
        <!-- Marco -->
        <rect x="2" y="2" width="60" height="60" fill="#FFF" stroke="#bbb" stroke-width="2" />

        <!-- Cabeza -->
        <circle cx="32" cy="20" r="12" fill="#bbb" />

        <!-- Cuerpo más ancho -->
        <path d="M12 55 A20 20 0 0 1 52 55 L52 55 L12 55 Z" fill="#bbb" stroke="#bbb" />

        <!-- Fondo blanco detrás del círculo de advertencia -->
        <circle cx="56" cy="55" r="14" fill="#fff " />

        <!-- Círculo de advertencia (sobresaliendo del borde) -->
        <circle cx="56" cy="55" r="11" fill="#f57a00" />

        <!-- Signo de exclamación: línea -->
        <rect x="55" y="48" width="2" height="8" fill="#fff" />

        <!-- Punto cuadrado -->
        <rect x="55" y="59" width="2" height="2" fill="#fff" />
    </svg>
</template>

<script>

export default {
    name: "AccountWarningIcon",

    props: {
        size: {
            type: [String, Number],
            default: 150,
        }
    }
};
</script>
